function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.207.793L1.5.086.086 1.5l.707.707L5.586 7 .793 11.793l-.707.707L1.5 13.914l.707-.707L7 8.414l4.793 4.793.707.707 1.414-1.414-.707-.707L8.414 7l4.793-4.793.707-.707L12.5.086l-.707.707L7 5.586 2.207.793z",
  fill: "#fff"
});

var SvgNavbarClose = function SvgNavbarClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjIwNzI2IDAuNzkyODkyTDEuNTAwMTUgMC4wODU3ODQ5TDAuMDg1OTM3NSAxLjVMMC43OTMwNDQgMi4yMDcxMUw1LjU4NTk0IDdMMC43OTMwNDQgMTEuNzkyOUwwLjA4NTkzNzUgMTIuNUwxLjUwMDE1IDEzLjkxNDJMMi4yMDcyNiAxMy4yMDcxTDcuMDAwMTUgOC40MTQyMUwxMS43OTMgMTMuMjA3MUwxMi41MDAyIDEzLjkxNDJMMTMuOTE0NCAxMi41TDEzLjIwNzMgMTEuNzkyOUw4LjQxNDM2IDdMMTMuMjA3MyAyLjIwNzExTDEzLjkxNDQgMS41TDEyLjUwMDIgMC4wODU3ODQ5TDExLjc5MyAwLjc5Mjg5Mkw3LjAwMDE1IDUuNTg1NzlMMi4yMDcyNiAwLjc5Mjg5MloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgNavbarClose as ReactComponent };